var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-tabs" }, [
    _c("div", { staticClass: "tabs-button" }, [
      _c(
        "div",
        {
          staticClass: "tab-btn hotel-btn",
          class: _vm.hotel,
          on: {
            click: function($event) {
              _vm.clickTab("hotel")
            }
          }
        },
        [
          _c("i", { staticClass: "iconfont icon-hotel1" }),
          _vm._v("\n            " + _vm._s(_vm.$t("hotel")) + "\n        ")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-btn flight-btn",
          class: _vm.flight,
          on: {
            click: function($event) {
              _vm.clickTab("flight")
            }
          }
        },
        [
          _c("i", { staticClass: "iconfont icon-feiji" }),
          _vm._v("\n            " + _vm._s(_vm.$t("flight")) + "\n        ")
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-panel" },
      [
        _c("fligh-search", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.type === "flight",
              expression: "type === 'flight'"
            }
          ]
        }),
        _vm._v(" "),
        _c("search-bar", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.type === "hotel",
              expression: "type === 'hotel'"
            }
          ],
          on: { "on-search": _vm.search, hot_hotle: _vm.hotsList }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b011c12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b011c12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Public/Search.vue
// module id = null
// module chunks = 